import React from "react"
import { createBrowserRouter, createMemoryRouter, type To } from "react-router"
import { Routes } from "./Routes"

const RootRoutes: React.FC = () => {
  return React.createElement(Routes)
}

export const router =
  typeof window !== "undefined" && typeof document !== "undefined"
    ? createBrowserRouter([{ path: "*", Component: RootRoutes }])
    : createMemoryRouter([{ path: "*", Component: RootRoutes }])

export interface ILocationCompat {
  pathname: string
  search: string
  hash: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state: any
  key: string
}

export interface IHistoryCompat {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  push: (to: To, state?: any) => Promise<void> | void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  replace: (to: To, state?: any) => Promise<void> | void
  go: (delta: number) => Promise<void> | void
  back: () => Promise<void> | void
  forward: () => Promise<void> | void
  location: ILocationCompat
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listen: (listener: (state: any) => void) => () => void
}

export const resolveTo = (to: To, baseHref?: string): To => {
  if (
    typeof to === "string" &&
    !to.startsWith("/") &&
    !to.startsWith("#") &&
    !to.startsWith("?") &&
    !to.includes(":")
  ) {
    const base = baseHref || (typeof window !== "undefined" && window.location?.href ? window.location.href : "http://localhost/")
    const url = new URL(to, base)
    return url.pathname + url.search + url.hash
  }
  return to
}

const history: IHistoryCompat = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  push: (to: To, state?: any) => {
    return router.navigate(resolveTo(to), { state })
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  replace: (to: To, state?: any) => {
    return router.navigate(resolveTo(to), { replace: true, state })
  },
  go: (delta: number) => {
    return router.navigate(delta)
  },
  back: () => {
    return router.navigate(-1)
  },
  forward: () => {
    return router.navigate(1)
  },
  get location(): ILocationCompat {
    return (
      router.state?.location || {
        pathname: typeof window !== "undefined" ? window.location.pathname : "/",
        search: typeof window !== "undefined" ? window.location.search : "",
        hash: typeof window !== "undefined" ? window.location.hash : "",
        state: null,
        key: "default"
      }
    )
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listen: (listener: (state: any) => void) => {
    return router.subscribe(listener)
  }
}

export default history
